import { PeakExceptionResponseCode, PeakPayrollExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";

export function GetExceptionsByExceptionCode(exception: any) {
  let exceptions: any = "";
  switch (exception.code) {
    case PeakPayrollExceptionCode.IsHaveEmployee:
      exceptions = i18n.t("Exceptions_Notification.IsHaveEmployee");
      break;
    case PeakPayrollExceptionCode.IsHaveSalaryEmployee:
      exceptions = i18n.t("Exceptions_Notification.IsHaveSalaryEmployee");
      break;
    case PeakPayrollExceptionCode.CodeDuplicated:
      exceptions = i18n.t("Exceptions_Notification.Pay_Run_Code_Duplicated", {
        number: exception.content,
      });
      break;
    case PeakPayrollExceptionCode.CodeIsEmpty:
      exceptions = i18n.t("Exceptions_Notification.CodeIsEmpty", {
        text: i18n.t("Pay_Run_Code"),
      });
      break;
    case PeakPayrollExceptionCode.ProplusCreateSalary:
      exceptions = i18n.t("Exceptions_Notification.ProplusCreateSalary");
      break;
    case PeakPayrollExceptionCode.ProplusCreateSummarySalaryPeriod:
      exceptions = i18n.t("Exceptions_Notification.ProplusCreateSummarySalaryPeriod");
      break;
    case PeakPayrollExceptionCode.CanNotPaidBeforeIssueDate:
      exceptions = i18n.t("Exceptions_Notification.CanNotPaidBeforeIssueDate");
      break;
    default:
      exceptions = exception.code
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
        : i18n.t("Something_Wrong");
      break;
  }
  return exceptions;
}

export function GetErrorMessageByExceptionCode(exception: any) {
  let errorMessage: any = "";
  switch (exception.code) {
    case PeakExceptionResponseCode.TransactionNumberDuplicated:
      errorMessage = i18n.t("Duplicated_Document_Number");
      break;
    case PeakExceptionResponseCode.ContactNotFound:
      errorMessage = i18n.t("Contact_Not_Found");
      break;
    case PeakExceptionResponseCode.LockByPeriod:
      errorMessage = i18n.t("LockPeriod_Alert") + new Date(exception.content).ToDateJsonString();
      break;
    case PeakExceptionResponseCode.LockByUser:
      errorMessage = i18n.t("Exception_Journal_Lock");
      break;
    case PeakExceptionResponseCode.CanNotSetDueDateBeforeTransactionDate:
      errorMessage = i18n.t("Cant_Set_Duedate_Before_Transaction_Date");
      break;
    case PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedBillingNote:
      errorMessage = i18n.t("Can_Not_Void_Invoice_IsIssued_BillingNote");
      break;
    case PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedCreditNote:
      errorMessage = i18n.t("Can_Not_Void_Invoice_IsIssued_CreditNote");
      break;
    default:
      errorMessage = exception.code
        ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
        : i18n.t("Something_Wrong");
      break;
  }
  return errorMessage;
}
